"use client";
import { FC } from "react";
import { ISubscriptionCardItem } from "../../interfaces/SubscriptionPlans.interface";
import { handleSubscriptionCTADL } from "./SubscriptionFunction";
import BFLLink from "@repo/shared-ui/BFLLink";
import { selectLoginStatus, useAppSelector } from "@repo/web-store";
import { useRouter } from "next/navigation";

export interface SubscriptionPlanLinkProps {
  item: ISubscriptionCardItem;
}

const SubscriptionPlanLink: FC<SubscriptionPlanLinkProps> = ({ item }) => {
  const loginStatus = useAppSelector(selectLoginStatus);
  const router = useRouter();

  /**
   * handleSubscriptionPlanClick
   */
  const handleSubscriptionPlanClick = (
    e: React.MouseEvent<HTMLSpanElement>,
  ) => {
    e?.preventDefault();
    const href = item["7 ctaUrl"];
    handleSubscriptionCTADL(
      loginStatus,
      "subscription_card_carousel", // sectionTitle (you may replace this with actual sectionTitle if dynamic)
      item.cardTitle,
      `${item.amountValue} / ${item.amountText}`,
      item.ctaText,
      href,
    );

    // redirect
    router.push(href);
  };

  return (
    <BFLLink
      href={item["7 ctaUrl"]}
      onClick={handleSubscriptionPlanClick}
      className="block w-full rounded-[200px] bg-[linear-gradient(to_right,#ff6700_67%,#ff8900)] px-0 py-[11px] text-center text-sm font-medium uppercase text-white"
    >
      {item.ctaText}
    </BFLLink>
  );
};

export default SubscriptionPlanLink;
